<template>
    <DModal
        is-big
        :show="showModal"
        :title="__('contracts.fulfillment.herold_at.modal_location_title')"
        @close="closeModal"
    >
        <div>
            <DRow class="pr-1 pb-2 row-width">
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_sid_input"
                        v-model="searchParams.sid"
                        type="number"
                        :label="__('contracts.fulfillment.herold_at.filters.sid')"
                        :invalid-feedback="errors.sid !== undefined ? errors.sid : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_name_input"
                        v-model="searchParams.name"
                        :label="__('contracts.fulfillment.herold_at.filters.name')"
                        :invalid-feedback="errors.name !== undefined ? errors.name : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_city_input"
                        v-model="searchParams.city"
                        :label="__('contracts.fulfillment.herold_at.filters.city')"
                        :invalid-feedback="errors.city !== undefined ? errors.city : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_street_input"
                        v-model="searchParams.street"
                        :label="__('contracts.fulfillment.herold_at.filters.street')"
                        :invalid-feedback="errors.street !== undefined ? errors.street : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_houseno_input"
                        v-model="searchParams.houseno"
                        :label="__('contracts.fulfillment.herold_at.filters.houseno')"
                        :invalid-feedback="errors.houseno !== undefined ? errors.houseno : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_postalcode_input"
                        v-model="searchParams.postalcode"
                        type="number"
                        :label="__('contracts.fulfillment.herold_at.filters.postalcode')"
                        :invalid-feedback="errors.postalcode !== undefined ? errors.postalcode : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_branchno_input"
                        v-model="searchParams.branchno"
                        :label="__('contracts.fulfillment.herold_at.filters.branchno')"
                        :invalid-feedback="errors.branchno !== undefined ? errors.branchno : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_phoneno_input"
                        v-model="searchParams.phoneno"
                        :label="__('contracts.fulfillment.herold_at.filters.phoneno')"
                        :invalid-feedback="errors.phoneno !== undefined ? errors.phoneno : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DInput
                        id="herold_website_input"
                        v-model="searchParams.website"
                        :label="__('contracts.fulfillment.herold_at.filters.website')"
                        :invalid-feedback="errors.website !== undefined ? errors.website : null"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="2"
                >
                    <DSelect
                        id="active-filter"
                        :label="__('contracts.fulfillment.herold_at.filters.active')"
                        :options="[
                            { value: null, label: 'All' },
                            { value: 'AK', label: 'Active' },
                            { value: 'IN', label: 'Inactive' },
                            { value: 'ST', label: 'St' }
                        ]"
                        @update:value="changeActiveFilter"
                    />
                </DCol>
                <DCol
                    class="pt-1 d-flex align-items-end justify-content-around"
                    sm="3"
                >
                    <div>
                        <DButton
                            id="herold_input_filter"
                            :label="__('contracts.fulfillment.herold_at.filters.search')"
                            color="secondary"
                            @click="getLocations"
                        />
                    </div>
                    <div>
                        <DButton
                            id="herold_reset_filters"
                            :label="__('contracts.fulfillment.herold_at.filters.reset_filters')"
                            color="secondary"
                            @click="resetFilters"
                        />
                    </div>
                </DCol>
            </DRow>
            <DRow class="row-width">
                <DFieldLoading
                    v-if="isLoading"
                    :is-loading="isLoading"
                    is-big
                    class="my-4 d-flex justify-content-center"
                />
                <h4
                    v-if="searchParamsNotApplied"
                    class="text-center py-4"
                >
                    {{ __('contracts.fulfillment.herold_at.modal_message') }}
                </h4>
                <DTable
                    v-if="!isLoading && !searchParamsNotApplied"
                    :fields="fields"
                    :items="locations"
                    :items-per-page="10"
                    pagination
                    :pagination-props="{align: 'center'}"
                >
                    <template #active="{item}">
                        <td>
                            <DTag
                                :color="item.active === 'AK' ? 'success' : item.active === 'IN' ? 'danger' : 'secondary'"
                                :label="item.active"
                            />
                        </td>
                    </template>
                    <template #yext_status="{item}">
                        <td>
                            <DTag
                                v-if="item.yext_status"
                                color="secondary"
                                :label="item.yext_status"
                            />
                        </td>
                    </template>
                    <template #actions="{item}">
                        <td style="padding: 5px !important;">
                            <DButton
                                id="select-location"
                                icon="check-circle"
                                color="success"
                                mini
                                @click="selectLocation(item)"
                            />
                        </td>
                        <td style="padding: 5px !important;">
                            <DButton
                                id="remove-location"
                                icon="trash-can-outline"
                                color="danger"
                                mini
                                @click="selectLocation(null)"
                            />
                        </td>
                    </template>
                </DTable>
            </DRow>
        </div>
    </DModal>
</template>

<script setup>

import { ref } from 'vue'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import DFieldLoading from '~@/Components/Common/DFieldLoading'

const props = defineProps({
    value: {
        type: Number,
        default: null
    },
    showModal: {
        type: Boolean,
        default: false
    },
    fulfillmentModule: {
        type: String,
        default: null
    }
})

const emit = defineEmits(['close-modal', 'update:modelValue'])

const fields = ref([
    { key: 'SID', label: __('contracts.fulfillment.herold_at.table.sid') },
    { key: 'company_name', label: __('contracts.fulfillment.herold_at.table.companyname') },
    { key: 'postal_code', label: __('contracts.fulfillment.herold_at.table.zip') },
    { key: 'city', label: __('contracts.fulfillment.herold_at.table.city') },
    { key: 'street', label: __('contracts.fulfillment.herold_at.table.street') },
    { key: 'country_code', label: __('contracts.fulfillment.herold_at.table.country_code') },
    { key: 'active', label: __('contracts.fulfillment.herold_at.table.active') },
    { key: 'yext_status', label: __('contracts.fulfillment.herold_at.table.yext') },
    { key: 'actions', label: '', _classes: 'text-right', filter: false }
])

const locations = ref([])
const isLoading = ref(false)
const searchParams = ref({
    name: null,
    postalcode: null,
    city: null,
    street: null,
    houseno: null,
    sid: null,
    active: null,
    branchno: null,
    phoneno: null,
    website: null
})
const errors = ref({})

const searchParamsNotApplied = ref(true)

searchPredefinedValue()

function searchPredefinedValue () {
    if (props.value !== null) {
        searchParams.value.sid = props.value
        getLocations()
    }
}

async function getLocations () {
    isLoading.value = true
    searchParamsNotApplied.value = false
    // Filter empty search parameters
    const requestData = Object.keys(searchParams.value).reduce(
        (res, key) => {
            const value = searchParams.value[key]
            if (value !== '' && value !== null) {
                res[key] = value
            }
            return res
        }, {})
    await window.axios.get(route('customers.herold_at.locations', requestData))
        .then((response) => {
            locations.value = response.data.locations
            errors.value = {}
        })
        .catch((error) => {
            if (error.response.data.errors !== undefined) {
                errors.value = error.response.data.errors
            }
            searchParamsNotApplied.value = true
        })
    isLoading.value = false
}

const closeModal = () => {
    resetFilters(true)
    emit('close-modal')
}

const selectLocation = (item) => {
    emit('update:modelValue', item ? { value: item.SID, display_value: item.SID + ' - ' + item.company_name } : { value: null, display_value: null })
}

const resetFilters = (closeModal) => {
    searchParams.value = {
        name: null,
        postalcode: null,
        city: null,
        street: null,
        houseno: null,
        sid: null,
        active: null,
        branchno: null,
        phoneno: null,
        website: null
    }
    searchParamsNotApplied.value = true
    errors.value = {}
    if (closeModal) {
        searchPredefinedValue()
    }
}

const changeActiveFilter = (filter) => {
    searchParams.value.active = filter
}
</script>

<style scoped>
    .row-width {
        margin: 0;
        width: 100%;
    }
</style>
